export const environment = {
  production: true,
  envName: 'prd',
  spa: {
    baseUrl: '/webapps',
    app: {
      cache: '/cache',
      res: '/reservation',
      srv: '/servicing',
      exc: '/exchange',
      cki: '/checkin',
    },
  },
  api: {
    baseUrl: 'https://space.ana.co.jp',
    clientId: '67c8758e541642f69baddc29863f63ad',
    clientSecret: 'CE2304e865164469a18b009a32351a7e',
    app: {
      sysdate: '/all-ibx-sysdate/api/v1',
      authorization: '/all-ibx-authorization/api/v1',
      initialization: '/all-ibx-initialization/api/v1',
      user: '/all-ibx-user/api/v1',
      amcmember: '',
      search: '/all-ibx-search/api/v1',
      reservation: '/all-ibx-reservation/api/v1',
      servicing: '/all-ibx-servicing/api/v1',
      exchange: '/all-ibx-exchange/api/v1',
      checkin: '/all-ibx-checkin/api/v1',
      member: '',
      credit: '',
    },
  },
  datadog: {
    disable: false,
    env: 'prd',
    clientToken: 'pub71ef99b3ce6dfa6584aae68f6452919e',
    versionFileRelativeUrl: '',
  },
  tealium: {
    disable: true,
    url: '',
  },
  dynatrace: {
    res: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/440e9ae69d378617_complete.js',
    },
    srv: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/d3a17547c0c5815f_complete.js',
    },
    exc: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/23b762b916072c56_complete.js',
    },
    cki: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/55ae8f4014f959f5_complete.js',
    },
  },
};
